module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-3-yellow.svg";